<template>
  <div class="ai-visibility-loading-state">
    <atom-spinner
      :animation-duration="1000"
      :size="70"
      :color="'var(--v-yellow2Color-base)'"
    />
    <span>{{ label }}</span>
  </div>
</template>

<script>
import { AtomSpinner } from 'epic-spinners'

export default {
  name: 'LoadingState',
  components: {
    AtomSpinner,
  },
  props: {
    label: {
      type: String,
      default: 'Loading AI Visibility data...',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-loading-state {
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  color: var(--v-mainColor-base);
  font-size: 16px;
  line-height: 1.5;
}
</style>
